import MarkdownLink from "./components/MarkdownLink";
import MarkdownCode from "./components/MarkdownCode";
import { MarkdownTableComponents } from "./components/MarkdownTable";
import { MarkdownCard } from "./components/MarkdownCard";
import MarkdownCopyButton from "./components/MarkdownCopyButton";



export const markdownComponents = {
  timeline: ({ node, children, ...props }: any) => {
    return <div {...props}>{children}</div>;
  },  
  a: MarkdownLink,
  code: MarkdownCode,
  div: MarkdownCard,
  button: MarkdownCopyButton,
  ...MarkdownTableComponents
};
